module.exports = __webpack_public_path__ + "20af2eb0413019c90c5d110ce694f8e5.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/parino.png
// module id = 616
// module chunks = 0